import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24 pb-16" data-testid="payment-cancel-page">
      <div className="max-w-lg w-full text-center p-12 rounded-3xl bg-white border" style={{ borderColor: "rgba(212,175,55,0.3)" }}>
        <XCircle size={56} className="mx-auto" style={{ color: "var(--navy)" }} />
        <h1 className="font-display text-4xl mt-6" style={{ color: "var(--navy)" }}>Checkout canceled</h1>
        <p className="font-body font-light mt-3" style={{ color: "var(--muted)" }}>
          No payment was made. Your preferred time isn't reserved yet — you can try again whenever you're ready.
        </p>
        <div className="flex gap-3 justify-center mt-8">
          <Link to="/contact" className="btn-primary">Reserve a Lesson</Link>
          <Link to="/" className="btn-secondary">Home</Link>
        </div>
      </div>
    </div>
  );
}
